import Cookies from "js-cookie";
import { useEffect, useState } from "react";
import { Button, Tab, Tabs } from "react-bootstrap";
import { IoArrowBackCircleSharp } from "react-icons/io5";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import franchiseAdminAPI from "../../../api/franchiseAdminAPI";
import BuyFrymes from "./BuyFrymes";
import SellFrymes from "./SellFrymes";

const Frymes = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();

  const activeTab = searchParams.get("tab") || "sell";
  const email = Cookies.get("userEmail");

  const [ledger, setLedger] = useState();

  useEffect(() => {
    if (email) {
      franchiseAdminAPI
        .getFrymeDetailsByEmail(email)
        .then((res) => {
          setLedger(res.data);
        })
        .catch((err) => {
          console.error("Error fetching ledger details:", err);
        });
    }
  }, [email]);

  useEffect(() => {
    if (!searchParams.get("tab")) {
      setSearchParams({ tab: "sell" });
    }
  }, []);
  const handleBack = () => {
    navigate("/master-admin-dashboard/franchises");
  };

  const handleTabChange = (key) => {
    setSearchParams({ tab: key });
  };

  return (
    <div className="scrollable-container" style={{ height: "100%" }}>
      <div className="header-container">
        <h1>
          <strong>Frymes</strong>
        </h1>

        <Button onClick={handleBack} variant="info" className="tooltip-btn">
          <IoArrowBackCircleSharp />
          <span className="tooltip-text">Go to Back</span>
        </Button>
      </div>
      <div>
        <span>
          Total Frymes Requested:
          {ledger?.totalQuantityFrymes || 0} || &nbsp; Used Frymes:{" "}
          {ledger?.usedFrymes || 0} || &nbsp; Balance Frymes:{" "}
          {ledger?.balancedFrymes || 0}
        </span>
      </div>

      <Tabs
        activeKey={activeTab}
        onSelect={handleTabChange}
        id="franchiseCustomers"
      >
        <Tab eventKey="sell" title="Sell Frymes">
          <SellFrymes />
        </Tab>

        <Tab eventKey="Buy" title="Buy Frymes">
          <BuyFrymes />
        </Tab>
      </Tabs>
    </div>
  );
};

export default Frymes;
